export default "__VITE_ASSET__392406d4__"